import React from 'react';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';

export const orderIcon = (
  value: boolean,
  selected: string,
  disabled: string
) => (
  <ShoppingBasketIcon
    style={{ width: '18', color: value ? selected : disabled }}
    id="iconMenu-icon-order"
  />
);
